<template>
  <div>
    <v-dialog v-model="createClientAccessDialog" scrollable max-width="500px">
      <v-card>
        <v-card-title>Create client access</v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-form ref="createClientAccessForm">
            <v-text-field
              v-model="clientAccessForm.clientPassword"
              label="Client access password"
              hint="At least 8 characters"
              prepend-icon="mdi-lock"
              :rules="[rules.min, rules.required]"
              @click:prepend="createPassword"
              clearable
              counter
            ></v-text-field>

            <v-menu
              v-model="clientAccessMenu"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="clientAccessForm.expiryDate"
                  :rules="[rules.required]"
                  label="Client access expiry date"
                  prepend-icon="mdi-calendar"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="clientAccessForm.expiryDate"
                @input="clientAccessMenu = false"
                first-day-of-week="1"
                :min="minDateAllowed"
              ></v-date-picker>
            </v-menu>
            <v-checkbox
              v-model="clientAccessForm.showPersonal"
              label="Show personal details"
            ></v-checkbox>
            <v-textarea
              filled
              v-model="clientAccessForm.description"
              name="input-7-4"
              :rules="[rules.required]"
              label="Brief description of client access"
            ></v-textarea>
          </v-form>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn
            color="blue darken-1"
            text
            @click="createClientAccessDialog = false"
            class="hp--btn"
            >Close</v-btn
          >
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            text
            @click="onCreateClientAccess()"
            class="hp--btn"
            >Save</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="updateClientAccessDialog" scrollable max-width="500px">
      <v-card>
        <v-card-title>Update client access</v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-form ref="updateClientAccessForm">
            <v-text-field
              v-model="updateClientAccessForm.clientPassword"
              label="Client access password"
              hint="At least 8 characters"
              prepend-icon="mdi-lock"
              :rules="[rules.min, rules.required]"
              @click:prepend="updatePassword"
              clearable
              counter
            ></v-text-field>

            <v-menu
              v-model="clientAccessMenu"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="updateClientAccessForm.expiryDate"
                  :rules="[rules.required]"
                  label="Client access expiry date"
                  prepend-icon="mdi-calendar"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="updateClientAccessForm.expiryDate"
                @input="clientAccessMenu = false"
                first-day-of-week="1"
                :min="minDateAllowed"
              ></v-date-picker>
            </v-menu>
            <v-checkbox
              v-model="updateClientAccessForm.showPersonal"
              label="Show personal details"
            ></v-checkbox>
            <v-textarea
              filled
              v-model="updateClientAccessForm.description"
              name="input-7-4"
              :rules="[rules.required]"
              label="Brief description of client access"
            ></v-textarea>
          </v-form>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn
            color="blue darken-1"
            text
            @click="updateClientAccessDialog = false"
            class="hp--btn"
            >Close</v-btn
          >
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            text
            @click="onUpdateClientAccess()"
            class="hp--btn"
            >Save</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-card class="mx-auto" max-width="1000">
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-btn
            color="info"
            dark
            small
            absolute
            top
            right
            fab
            v-on="on"
            @click="sendMessageToParent"
            class="hp--btn"
          >
            <v-icon>keyboard_return</v-icon>
          </v-btn>
        </template>
        <span>View companies</span>
      </v-tooltip>

      <v-toolbar flat>
        <v-toolbar-title class="grey--text">Client Access Area</v-toolbar-title>
        <div class="flex-grow-1"></div>
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn
              color="primary"
              dark
              small
              absolute
              bottom
              fab
              v-on="on"
              @click="createClientAccessDialog = !createClientAccessDialog"
              class="hp--btn"
            >
              <v-icon>mdi-plus</v-icon>
            </v-btn>
          </template>
          <span>Create client access</span>
        </v-tooltip>
      </v-toolbar>
      <v-divider></v-divider>
      <v-card-text>
        <v-alert dense text type="success" v-if="viewMessage">
          {{ message }}
          <strong>clipboard</strong>
        </v-alert>
        <v-data-table
          :items="clientAccess"
          :headers="clientAccessHeaders"
          class="elevation-1"
          :page.sync="page"
          :items-per-page="itemsPerPage"
          :search="search"
          :sort-by="['address1, address2']"
        >
          <template v-slot:item.expiryDate="{ item }">
            {{ new Date(item.expiryDate) | moment("Do MMMM YYYY") }}
          </template>
          <template v-slot:item.action="{ item }">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-icon v-on="on" color="secondary" @click="copyUrl(item)"
                  >content_copy</v-icon
                >
              </template>
              <span>Copy URL</span>
            </v-tooltip>

            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-icon v-on="on" color="info" @click="copyPassword(item)"
                  >lock_open</v-icon
                >
              </template>
              <span>Copy password</span>
            </v-tooltip>

            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-icon
                  v-on="on"
                  color="success"
                  @click="editClientAccess(item)"
                  >edit</v-icon
                >
              </template>
              <span>Update client access</span>
            </v-tooltip>

            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-icon
                  v-on="on"
                  @click="deleteClientAccess(item)"
                  color="error"
                  >delete</v-icon
                >
              </template>
              <span>Delete client access</span>
            </v-tooltip>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import moment from "moment";
import { ClientAccess } from "../classes/ClientAccess";
import _ from "lodash";
export default {
  props: {
    company: Object
  },
  data() {
    return {
      createClientAccessDialog: false,
      updateClientAccessDialog: false,
      clientAccessForm: {
        clientPassword: null,
        expiryDate: null,
        showPersonal: false
      },
      updateClientAccessForm: {
        clientPassword: null,
        expiryDate: null,
        showPersonal: false
      },
      clientAccess: [],
      minDateAllowed: moment().toISOString(),
      rules: {
        required: v => !!v || "This field is required.",
        email: v => /.+@.+\..+/.test(v) || "E-mail must be valid",
        min: v => (!!v && v.length >= 8) || "Min 8 characters"
      },
      clientAccessMenu: false,
      clientAccessHeaders: [
        {
          text: "Description",
          align: "left",
          value: "description"
        },
        { text: "Expiry", value: "expiryDate" },
        { value: "action", align: "right", sortable: false }
      ],
      page: 0,
      search: "",
      itemsPerPage: -1,
      viewMessage: false,
      message: ""
    };
  },
  async created() {
    const that = this;
    const clientAccess = await new ClientAccess().getClientAccessByCompany(
      this.company
    );
    clientAccess.forEach(function(access) {
      that.clientAccess.push({
        id: access.id,
        clientPassword: access.clientPassword,
        expiryDate: access.expiryDate,
        showpersonal: access.showpersonal ? true : false,
        description: access.description
      });
    });
    that.clientAccess = _.orderBy(that.clientAccess, "description", "asc");
  },
  methods: {
    sendMessageToParent() {
      this.$emit("switchEventPanel", "companies");
    },
    createPassword() {
      this.clientAccessForm.clientPassword = Math.random()
        .toString(36)
        .substring(3);
    },
    updatePassword() {
      this.updateClientAccessForm.clientPassword = Math.random()
        .toString(36)
        .substring(3);
    },
    async onCreateClientAccess() {
      if (this.$refs.createClientAccessForm.validate()) {
        const clientAccess = await new ClientAccess().createClientAccess(
          this.company,
          this.clientAccessForm
        );
        this.clientAccess.push({
          id: clientAccess.id,
          clientPassword: clientAccess.clientPassword,
          expiryDate: clientAccess.expiryDate,
          showpersonal: clientAccess.showpersonal ? true : false,
          description: clientAccess.description
        });
        this.createClientAccessDialog = false;
      }
    },
    async editClientAccess(item) {
      const clientAccess = await new ClientAccess().getClientAccessById(item);
      this.updateClientAccessForm.id = clientAccess.id;
      this.updateClientAccessForm.clientPassword = clientAccess.clientPassword;
      this.updateClientAccessForm.showPersonal = clientAccess.showPersonal
        ? true
        : false;
      this.updateClientAccessForm.description = clientAccess.description;
      this.updateClientAccessForm.expiryDate = clientAccess.expiryDate;
      this.updateClientAccessDialog = true;
    },
    async deleteClientAccess(item) {
      const that = this;
      if (item.id) {
        const clientAccess = await new ClientAccess().deleteClientAccess(item);
        that.clientAccess = this.clientAccess.filter(
          item => item.id !== clientAccess.id
        );
      }
    },
    async onUpdateClientAccess() {
      const that = this;
      if (this.$refs.updateClientAccessForm.validate()) {
        const clientAccess = await new ClientAccess().updateClientAccess(
          that.updateClientAccessForm
        );

        const index = that.clientAccess.findIndex(
          access => access.id === clientAccess.id
        );
        Object.assign(that.clientAccess[index], clientAccess);
        this.updateClientAccessDialog = false;
      }
    },
    copyPassword(item) {
      this.clipboardCopy(item.clientPassword);
      this.viewMessage = true;
      this.message = "Password copied into";
    },
    copyUrl(item) {
      this.clipboardCopy(`${window.location.origin}/client-access/${item.id}`);
      this.viewMessage = true;
      this.message = "URL copied into";
    },
    clipboardCopy(text) {
      var dummy = document.createElement("textarea");
      document.body.appendChild(dummy);
      dummy.value = text;
      dummy.select();
      document.execCommand("copy");
      document.body.removeChild(dummy);
    }
  }
};
</script>
